import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Theme,
  WithStyles,
  withStyles,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Fab,
  Typography,
} from "@material-ui/core";
import * as React from "react";
import AddIcon from "@material-ui/icons/Add";
import emptyTrash from "../assets/images/empty_trash.png";
import AddFormsInputItem from "./AddFormsInputItem";
import SortableListComponent from "../components/SortableListComponent";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = (theme: Theme) =>
  createStyles({
    button: { margin: theme.spacing(2) },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    image: {
      width: 128,
      height: 128,
    },
    table: {
      minWidth: 150,
    },
    margin: {
      margin: theme.spacing(1),
    },
    sorting: {
      zIndex: theme.zIndex.modal + 100,
    },
    img: {
      "max-width": 120,
      "max-height": 120,
      overflow: "hidden",
    },
  });
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  handleClose: any;
  handleOnSubmit: any;
  editData: any;
  companyData: any;
  equipments: any;
  uniqueNames: any;
  uniqueTypes: any;
  uniqueMachineNumbers: any;
}

class AddFormsItemDialog extends React.Component<Props> {
  state = {
    formsInputItems: Array<any>(),
    selectedformsInputItem: { formsInput: "" },
    selectedIndex: -1,
    openAddFormsInputItemDialog: false,
  };
  componentDidMount = () => {
    this.setState({
      formsInputItems: this.props.editData ? this.props.editData : [],
    });
  };
  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.editData !== this.props.editData) {
      this.setState({
        formsInputItems: this.props.editData ? this.props.editData : [],
      });
    }
  }

  handleAddButton = () => {
    this.setState({
      openAddFormsInputItemDialog: true,
    });
  };
  handleSaveButton = () => {
    const { handleOnSubmit } = this.props;
    let formsInputItems = this.state.formsInputItems;
    handleOnSubmit(formsInputItems);
  };
  isValid = () => {
    let { editData } = this.props;
    if (editData && editData.length > 0) {
      let formsInputItemsValid = editData && editData.length > 0 ? true : false;
      return !formsInputItemsValid;
    } else {
      let formsInputItemsValid =
        this.state.formsInputItems && this.state.formsInputItems.length > 0
          ? true
          : false;
      return !formsInputItemsValid;
    }
  };
  handleEditFormsItem = (formsInputItem: any, index: any) => {
    this.setState({
      selectedformsInputItem: formsInputItem,
      selectedIndex: index,
      openAddFormsInputItemDialog: true,
    });
  };
  handleDeleteFormsItem = (formsInputItem: any, index: any) => {
    let formsInputItems = this.state.formsInputItems;
    formsInputItems.splice(index, 1);
    this.setState({
      formsInputItems: formsInputItems,
      openAddFormsInputItemDialog: false,
    });
  };
  onAddQuestionSubmit = (values: any) => {
    let formsInputItems = this.state.formsInputItems
      ? this.state.formsInputItems
      : [];
    formsInputItems.push(values);
    this.setState({
      formsInputItems: formsInputItems,
      openAddFormsInputItemDialog: false,
    });
  };
  onEditQuestionSubmit = (values: any) => {
    if (this.state.selectedIndex > -1) {
      let formsInputItems = this.state.formsInputItems
        ? this.state.formsInputItems
        : [];
      formsInputItems[this.state.selectedIndex] = values;
      this.setState({
        formsInputItems: formsInputItems,
        selectedformsInputItem: {},
        selectedIndex: -1,
        openAddFormsInputItemDialog: false,
      });
    }
  };
  renderAddFormsItemDialog = () => {
    return (
      <AddFormsInputItem
        title={"Add Forms Item"}
        open={this.state.openAddFormsInputItemDialog}
        handleClose={() =>
          this.setState({
            openAddFormsInputItemDialog: false,
            selectedIndex: -1,
            selectedformsInputItem: {},
          })
        }
        companyData={this.props.companyData}
        editData={
          this.state.selectedformsInputItem
            ? this.state.selectedformsInputItem
            : undefined
        }
        uniqueMachineNumbers={this.props.uniqueMachineNumbers}
        uniqueNames={this.props.uniqueNames}
        uniqueTypes={this.props.uniqueTypes}
        equipments={this.props.equipments}
        handleOnSubmit={
          this.state.selectedformsInputItem &&
          this.state.selectedformsInputItem.formsInput
            ? this.onEditQuestionSubmit
            : this.onAddQuestionSubmit
        }
      />
    );
  };
  onSortFinish = (newSortedArray: any) => {
    this.setState({
      formsInputItems: newSortedArray,
    });
  };

  render() {
    const { title, open, handleClose, classes } = this.props;
    return (
      <React.Fragment>
        <Dialog
          open={open}
          keepMounted={true}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          maxWidth={"md"}
          fullWidth={true}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
            <Fab
              variant="extended"
              style={{ backgroundColor: "white", margin: 10 }}
              onClick={() => this.handleAddButton()}
            >
              <AddIcon className={classes.extendedIcon} />
              {"Form Item"}
            </Fab>
          </div>
          <Divider />
          <DialogContent>
            {this.state.formsInputItems &&
            this.state.formsInputItems.length > 0 ? (
              <SortableListComponent
                items={this.state.formsInputItems}
                sorting={classes.sorting}
                onSortFinish={this.onSortFinish}
                editAction={this.handleEditFormsItem}
                deleteAction={this.handleDeleteFormsItem}
                renderItem={(item: any, index: any) => {
                  return (
                    <div style={{ flexDirection: "row", display: "flex" }}>
                      <ListItemAvatar>
                        <Avatar>{item.usedAsSearch ? "SE" : "NS"}</Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={item.formsInput}
                        secondary={`${item.responseType} SE/NS(Search Enabled/No Search)`}
                      />
                    </div>
                  );
                }}
              />
            ) : (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "auto",
                }}
              >
                <img
                  src={emptyTrash}
                  style={{ width: 40, height: 40 }}
                  alt="Empty Trash"
                />
                <Typography
                  variant="h5"
                  gutterBottom
                  style={{ marginTop: 10, textAlign: "center" }}
                >
                  {"Empty".toUpperCase()}
                </Typography>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                handleClose();
              }}
            >
              {"CANCEL"}
            </Button>
            <Button
              disabled={this.isValid()}
              onClick={() => this.handleSaveButton()}
            >
              {"SAVE"}
            </Button>
          </DialogActions>
        </Dialog>
        {this.renderAddFormsItemDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddFormsItemDialog);
